import { NgModule } from '@angular/core';
import { CuitPipe } from './cuit.pipe';
import { DocumentoPipe } from './documento.pipe';
import { FormatTimePipe } from './format-time.pipe';
import { MontoPipe } from './monto.pipe';
import { NumeroPipe } from './numero.pipe';
import { CapitalizeReplacePipe } from '../capitalize-replace.pipe';




@NgModule({
  declarations: [
    CuitPipe,
    DocumentoPipe,
    FormatTimePipe,
    MontoPipe,
    NumeroPipe,
    CapitalizeReplacePipe
  ],
  imports: [

  ],
  exports: [
    CuitPipe,
    DocumentoPipe,
    FormatTimePipe,
    MontoPipe,
    NumeroPipe,
    CapitalizeReplacePipe
  ]
})
export class SharedPipesModule { }
